import React from "react";
import ReactDOM from 'react-dom';
import SliderContent from "./SliderContent";
class Banner extends React.Component {

  componentDidMount(){
    ReactDOM.findDOMNode(this);
  }

  render() {
    const firstSlide = {
      background: "url(/images/110618-006.jpg)"
    };
    const secondSlide = {
      background: "url(/images/110618-008.jpg)"
    };

    const { type } = this.props;

    return (
      <section className="bg-home-slider" id="">
        <div className="container-fluid">
          <div className="row">
            <div
              id="carouselExampleFadeWifi"
              className="carousel slide carousel-fade"
              data-ride="carousel"
              data-interval="5000"
            >
              <div className="carousel-inner">
                <div
                  className={type === undefined || type !== "global" ? "carousel-item first-slide h-100vh active" : "carousel-item h-100vh"}
                  data-slide-to="0"
                  style={firstSlide}
                >
                  <div className="bg-overlay" />
                  <SliderContent title="Limited Time Promotion #1" promotion="159" />
                </div>
                <div className={type !== undefined && type === "global" ? "carousel-item second-slide h-100vh active" : "carousel-item h-100vh"}

                   data-slide-to="1"
                   style={secondSlide}>
                  <div className="bg-overlay" />
                  <SliderContent title="Limited Time Promotion #2" promotion="119" />
                </div>
              </div>
              <a
                className="carousel-control-prev"
                href="#carouselExampleFadeWifi"
                role="button"
                data-slide="prev"
              >
                <span className="pe-7s-angle-left" aria-hidden="true" />
                <span className="sr-only">Previous</span>
              </a>
              <a
                className="carousel-control-next"
                href="#carouselExampleFadeWifi"
                role="button"
                data-slide="next"
              >
                <span className="pe-7s-angle-right" aria-hidden="true" />
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/getwifius/Banner.js